import { types } from "../Types/drawer";

export function toggleDrawer() {
  return {
    type: types.TOGGLE_DRAWER
  };
}
